<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="50%"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row :gutter="32">
                <Col span="24">
                    <DescriptionList class="show-description-title" title="" :col="3"  layout="vertical">
                        <Description term="编号：">
                            {{detail.sn}}
                        </Description>
                        <Description term="状态：">
                            <Badge v-if="detail.status === 1" color="blue" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 2" color="red" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 3" color="green" :text="detail.status_name" />
                            <Badge v-else color="#999999" text="其他" />
                        </Description>
                        <Description term="零星项目：">
                            {{detail.project_name || '-'}}
                        </Description>
                        <Description term="甲方：" v-if="kind === 1">
                            {{detail.customer_name ?? '-'}}
                        </Description>
                        <Description term="维保记录：" v-if="kind === 1">
                            {{detail.maintain_title ?? '-'}}
                        </Description>
                        <Description term="开票公司：">
                            {{detail.inv_company_name ?? '-'}}
                        </Description>
                        <Description term="发票类型：">
                            <Tag>{{detail.inv_type_name}}</Tag>
                        </Description>
                        <Description term="开票金额：">
                            <Tag color="blue">{{detail.inv_money}}</Tag>
                        </Description>
                        <Description term="到账金额：" v-if="kind === 1">
                            <Tag color="green">{{detail.get_money}}</Tag>
                        </Description>
                        <!-- 支出发票：发票名称 -->
                        <Description term="发票名称：" v-if="kind === 2">
                            {{detail.title ?? '-'}}
                        </Description>
                        <!-- 收入发票：开票信息 -->
                        <template v-if="kind === 1">
                            <Description term="发票抬头：">
                                {{detail.inv_head}}
                            </Description>
                            <Description term="发票税号：">
                                {{detail.inv_num ?? '-'}}
                            </Description>
                            <Description term="联系电话：">
                                {{detail.inv_tel ?? '-'}}
                            </Description>
                            <Description term="发票地址：">
                                {{detail.inv_address ?? '-'}}
                            </Description>
                            <Description term="开户银行：">
                                {{detail.inv_bank ?? '-'}}
                            </Description>
                            <Description term="银行卡号：">
                                {{detail.inv_bank_card ?? '-'}}
                            </Description>
                        </template>
                        <Description term="发票附件：" v-if="detail.invoice_image">
                            <a href="javascript:void(0);" @click="FileDownload(detail.invoice_image)">下载文件</a>
                        </Description>
                        <Description term="申请人：">
                            {{detail.apply_name}}
                        </Description>
                        <Description term="申请时间：">
                            {{detail.apply_time}}
                        </Description>
                        <Description term="驳回原因：" v-if="detail.status === 2">
                            <span class="text-danger">{{detail.reject_remark}}</span>
                        </Description>
                        <Description term="驳回时间：" v-if="detail.status === 2">
                            {{detail.reject_time}}
                        </Description>
                        <Description term="审核人：" v-if="detail.auditor_name">
                            {{detail.auditor_name}}
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                        <Description term="备注信息：">
                            {{detail.remark}}
                        </Description>
                    </DescriptionList>
                </Col>
            </Row>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedInvoiceDetail} from "@/apis/dispersed";

export default {
    name: 'DispersedInvoiceShow',
    components: {
    },
    props: {
        kind: {
            type: [Number, String],
            default: 1
        }
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '发票详情',
            isBox : false,
            site_url : this.$siteApi,
            detail: []
        }
    },
    methods: {

        /**
         * 功能：文件下载
         * time: 2026/09/13
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },

        /**
         * 功能：详情
         * time: 2026/09/13
         **/
        GetDetail(invoice_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedInvoiceDetail(invoice_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         * 功能：打开
         * time: 2026/09/13
         **/
        show(invoice_id){
            this.isBox = true;
            if(invoice_id) this.GetDetail(invoice_id);
        },
        /**
         * 功能：重置
         * time: 2026/09/13
         **/
        FormReset(){
            this.isBox = false;
            this.title = '发票详情';
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
